import { render, staticRenderFns } from "./vendor-form.vue?vue&type=template&id=09143252&scoped=true"
import script from "./vendor-form.vue?vue&type=script&lang=js"
export * from "./vendor-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09143252",
  null
  
)

export default component.exports